module.exports = __webpack_public_path__ + "fonts/Mukta-400-devanagari7.ac67abc.woff2";